import { userConstants } from "../../constant";

const initialState = {
  current_price: null,
  price_history: [],
  slug: null,
};

export function priceHistory(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_PRICE_HISTORY:
      return {
        ...state,
        current_price: action.payload.current_price,
        price_history: action.payload.price_history || [],
        slug: action.payload.slug,
      };
    default:
      return state;
  }
}
